import {DetailService, SearchRepository, SearchService} from '@aipb/gulliver/catalog/data-access';
import {CatalogEnvService} from '@aipb/gulliver/catalog/env';
import {CustomRecordItem, ResultListMode, SearchItem} from '@aipb/gulliver/catalog/model';
import {CatalogRouting} from '@aipb/gulliver/catalog/routing';
import {createDetailCompositeKey} from '@aipb/gulliver/catalog/util';
import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {ResultListBasicCompactComponent} from '../result-list-basic-compact/result-list-basic-compact.component';
import {ResultListBasicComponent} from '../result-list-basic/result-list-basic.component';
import {ResultListMasonryComponent} from '../result-list-masonry/result-list-masonry.component';
import {ResultListTileComponent} from '../result-list-tile/result-list-tile.component';
import {ResultListToolbarComponent} from '../result-list-toolbar/result-list-toolbar.component';
import {ResultListMasonrySimpleComponent} from '../result-list-masonry-simple/result-list-masonry-simple.component';
import {ResultListTileSimpleComponent} from '../result-list-tile-simple/result-list-tile-simple.component';

@UntilDestroy()
@Component({
  selector: 'cat-result-list',
  templateUrl: './result-list.component.html',
  styleUrls: ['./result-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ResultListTileComponent,
    ResultListBasicComponent,
    ResultListBasicCompactComponent,
    ResultListMasonryComponent,
    ResultListToolbarComponent,
    ResultListMasonrySimpleComponent,
    ResultListTileSimpleComponent
  ]
})
export class ResultListComponent {
  @Input() searchItem: SearchItem;
  @Input() resultListMode: ResultListMode;

  private searchRepository = inject(SearchRepository);
  resultListMode$ = this.searchRepository.resultListMode$;
  private detailService = inject(DetailService);
  private catalogRouting = inject(CatalogRouting);
  private catalogEnv = inject(CatalogEnvService);
  private searchService = inject(SearchService);
  private _lastPage: number;

  onDetail(item: CustomRecordItem): void {
    this.detailService.addTab(
      {
        id: createDetailCompositeKey(this.searchItem.coreId, item[this.catalogEnv.env.castor.UUID]),
        query: this.searchItem.search.q,
        title: item.GulliverTabName,
        type: item.GulliverRecType,
        image:
          item.GulliverRecType !== 'Dropbox' && item.header?.images?.length > 0
            ? item.header.images[0].thumb || item.header.images[0].large
            : null
      },
      true
    );
    this.catalogRouting.detailDefault();
  }

  onPageChange(page: number): void {
    if (page === this._lastPage) return;

    this.searchService.paginate(this.searchItem.id, page);
    this._lastPage = page;
  }
}
